// Webpack Imports
import { Alert, Carousel, Offcanvas } from 'bootstrap';

( function () {
	'use strict';

	// ScrollProgressBar
	var bs_primary = getComputedStyle(document.documentElement).getPropertyValue('--bs-orange');
	new ScrollProgressBar({color: bs_primary, size: '4px', placement: 'bottom'}).start();

	// CTA Device buttons
	var ctaDevice = document.getElementById("starter-kit-cta");
	if ( ctaDevice ) {
		var ctaLink = ctaDevice.querySelector("a");
		gsap.set("#device-btn-l", {transformOrigin: "center right"});
		gsap.set("#device-btn-r", {transformOrigin: "centerright"});
		var ctaAnim = gsap.timeline({paused:true, duration: 0, ease: 'power1.in'})
		.to("#device-btn-l, #device-btn-r", {strokeWidth: 4, scaleX: .5}, 0);
		ctaLink.addEventListener("mouseenter", function() { ctaAnim.play(); });
		ctaLink.addEventListener("mouseleave", function() { ctaAnim.reverse(); });
	}

	if ( $('.phone-format').length ) {
		new Cleave('.phone-format', {
			phone: true,
			phoneRegionCode: 'US'
		});
	}

	if ( $('#flamingo-userAgent').length ) {
		$('#flamingo-userAgent').val(navigator.userAgent);
	}

	//var menuAnchors = document.getElementById("elementor-widget-menu-anchor");

	// remove text from social menu
	[].forEach.call( document.querySelectorAll( "#menu-social a" ), ( el ) => {
		el.textContent = '';
	} );

	function lottieAdjust() {
		$('.e-lottie__container').each(function(i, obj) {
			const w = $(this).find(".e-lottie__animation").width();
			$(this).height(w + 'px');
		});
	};
	if ( $('.e-lottie__container').length ) {
		lottieAdjust();
		$(window).on('resize', lottieAdjust);
	}

	// animations for homepage
	if ( document.body.classList.contains('home') ) {
		let tl_hero_trigger = '#hero';
		let tl_spin_trigger = '#section-spin';
		let tl_video_trigger = '#section-video';
		var video = document.getElementById("home-video").getElementsByClassName("elementor-video");
		var video_overlay = document.getElementById("home-video").getElementsByClassName("elementor-custom-embed-image-overlay");
		if (video && video.length > 0) {};
		let tl_textblock_trigger = '#section-textblock';

		var hash = $(location).attr('hash');
		if (hash == tl_video_trigger) {
			gsap.to(window, {duration: 1, scrollTo: tl_video_trigger});
		}

		ScrollTrigger.saveStyles([
			tl_hero_trigger,
			tl_spin_trigger,
			tl_video_trigger,
			tl_textblock_trigger,
		]);

		gsap.set(tl_spin_trigger + " .device-spin", { autoAlpha: 0 });
		$('.take-a-spin').on('click', function(e){
			e.preventDefault();
			gsap.to('.take-a-spin', {x: 200, onComplete: function(){ $(this).remove(); } });
			gsap.to(tl_spin_trigger + " .spot-main", {x: -500, onComplete: function(){ $(tl_spin_trigger + " .spot-main").remove(); } });
			gsap.to(tl_spin_trigger + " .device-spin", { autoAlpha: 1 });
			$(tl_spin_trigger + " .device-spin svg").trigger('click');
		});

		ScrollTrigger.matchMedia({
			// Desktop
			"(min-width: 1025px)": function() {
				// hero
				let tl_hero = gsap.timeline({
					scrollTrigger: {
						trigger: tl_hero_trigger,
						start: 0,
						end: "bottom top",
						scrub: true,
						pin: true,
					}
				})
				//.from(tl_hero_trigger + " .hero-subtitle", { y: 40, autoAlpha: 0, ease: 'power1.in'}, 0)
				.fromTo(tl_hero_trigger + " .hero-device-svg",  { autoAlpha: 0, scale: .25 }, { autoAlpha: 1, scale: 1, ease: 'power1.in' }, 0)
				.fromTo(tl_hero_trigger + " .hero-btn", { autoAlpha: 0 }, { autoAlpha: 1 }, 0)
				.fromTo(tl_hero_trigger + " .hero-lead .elementor-widget-container", { x: -600, autoAlpha: 0, ease: 'power1.in' }, { x: 185, autoAlpha: 1, ease: 'power1.in' }, 0)
				.to(tl_hero_trigger + " .hero-title-1", { y: -40, ease: 'power1.in'}, 0)
				.to(tl_hero_trigger + " .hero-title-2", { y: -40, ease: 'power1.in'}, 0)
				.to(tl_hero_trigger + " .hero-device",  { x: -470, y: 320, autoAlpha: 0, transformOrigin:'center center', rotation: "90_ccw", scale: .25, ease: 'power1.in' }, 0);

				let tl_spin = gsap.timeline({
					scrollTrigger: {
						trigger: tl_spin_trigger,
						start: "top-=100% center",
						end: "center center",
						scrub: true,
						//markers: true
					}
				})
				.set(tl_spin_trigger + " .spot-main", { x: -500, y: 100 })
				.set(tl_spin_trigger + " .spot-top", { x: -300, y: -100, rotation: 50 })
				.set(tl_spin_trigger + " .spot-middle",  { x: -5, y: 150 })
				.set(tl_spin_trigger + " .spot-bottom", { x: -500, y: 20 })
				.set(tl_spin_trigger + " .spin-text", { y: innerHeight })
				.to(tl_spin_trigger + " .spot-main", { x: -150, y: 40, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-top", { x: -70, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-middle", { y: 25, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-bottom", { x: -60, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spin-text", { y: 5, ease: 'power1.inOut' }, 0);

				let tl_textblock = gsap.timeline({
					scrollTrigger: {
						trigger: tl_textblock_trigger,
						start: "top-=15% center",
						end: "+=50%",
						scrub: true,
					}
				})
				.from(tl_textblock_trigger + " .text", { y: 100, autoAlpha: 0, ease: 'power1.inOut' })
				.to(tl_textblock_trigger + " .text span", { color: '#fff' }, 1);
			},
			"(min-width: 577px) and (max-width: 1024px)": function() {
				let tl_hero = gsap.timeline({
					scrollTrigger: {
						trigger: tl_hero_trigger,
						start: 0,
						end: "bottom top",
						scrub: true,
						pin: true,
					}
				});
				tl_hero
				//.from(tl_hero_trigger + " .hero-subtitle", { y: 40, autoAlpha: 0, ease: 'power1.in'}, 0)
				.fromTo(tl_hero_trigger + " .hero-device-svg",  { autoAlpha: 0, scale: .25 }, { autoAlpha: 1, scale: 1, ease: 'power1.in' }, 0)
				.fromTo(tl_hero_trigger + " .hero-btn", { autoAlpha: 0 }, { autoAlpha: 1 }, 0)
				.fromTo(tl_hero_trigger + " .hero-lead .elementor-widget-container", { x: -300, autoAlpha: 0, ease: 'power1.in' }, { x: 100, autoAlpha: 1, ease: 'power1.in' }, 0)
				.to(tl_hero_trigger + " .hero-title-1", { y: -60, ease: 'power1.in'}, 0)
				.to(tl_hero_trigger + " .hero-title-2", { y: -60, ease: 'power1.in'}, 0)
				.to(tl_hero_trigger + " .hero-device",  { x: -470, y: 320, autoAlpha: 0, transformOrigin:'center center', rotation: "90_ccw", scale: .25, ease: 'power1.in' }, 0);

				let tl_spin = gsap.timeline({
					scrollTrigger: {
						trigger: tl_spin_trigger,
						start: "top-=100% center",
						end: "center center",
						scrub: true,
						//markers: true
					}
				});
				tl_spin
				.set(tl_spin_trigger + " .spot-main", { x: -500, y: 100 })
				.set(tl_spin_trigger + " .spot-top", { x: -300, y: -100, rotation: 50 })
				.set(tl_spin_trigger + " .spot-middle",  { x: -5, y: 150 })
				.set(tl_spin_trigger + " .spot-bottom", { x: -500, y: 20 })
				.to(tl_spin_trigger + " .spot-main", { x: -150, y: 40, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-top", { x: -70, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-middle", { y: 25, ease: 'power1.inOut' }, 0)
				.to(tl_spin_trigger + " .spot-bottom", { x: -60, ease: 'power1.inOut' }, 0);
			},
			"(max-width: 576px)": function() {
				gsap
				.set(tl_spin_trigger + " .spot-main", { x: -140, y: 20 });
			},
			"all": function() {
				ScrollTrigger.create({
					trigger: tl_video_trigger,
					start: "top center",
					end: "bottom center",
					scrub: true,
					onToggle: self => {
						if (self.isActive) {
							if (video_overlay && video_overlay.length > 0) {
								setTimeout(function () {
									$(video_overlay).fadeOut(500);
								}, 2000);
							} else {
								video[0].play();
							}
						} else {
							video[0].pause();
						}
					},
					toggleActions: 'play pause reverse none'
				});
			}
		});
	}

} )();
